// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import Close from "@rpsc/XDL/Icons/IconClose";
import { buttonTransparent } from "@rpsc/XDL/PreStyle/button";
import { xBaseTheme } from "@rpsc/XDL/types";
import { color, styledScrollbar, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 432,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        headlineTypographyProps: {
            variant: "h3",
            css: css`
                margin: 0;
            `,
        },
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
            `,
            modalTitle: css`
                position: relative;
                padding: 17px 16px 1px;
                border-bottom: 0;
                align-items: flex-start;
            `,
            modalContent: css`
                ${styledScrollbar()}
                padding: 16px;
            `,
            modalBody: css`
                overflow: hidden;
                border-radius: 2px;
                background-color: ${color("common.white")};
                box-shadow: 0 0 8px 0 ${color("common.ui7", 0.5)};
                ${xScreen("lte", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 30px);
                    margin: 15px;
                }
            `,
        },
        closeButtonProps: {
            shape: "pill",
            variant: "tertiary",
            css: css`
                padding: 0;
                min-height: initial;
                width: 30px;
                height: 30px;
                padding: 8px;
                ${buttonTransparent}
                & ${IconWrapper}, & svg {
                    width: 14px;
                    height: 14px;
                    top: 0;
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 14,
            color: "primary",
        },
    },
} as xBaseTheme["modal"];
